export const css = {
	root: '_1XW8Wyt9',
	loading: '_1ft3Mimk',
	titleBlock: 'SYq1KF58',
	title: '_1jue7dn0',
	questionBlock: '_3I7KC8uM',
	count: '_3YDXFcZb',
	question: '_3rYMBFS8',
	select: 'm2Tg-HEL',
	microViewWrapper: '_3V-m2e1h',
	microView: '_3f5CRBKg',
	' _key': 'certwise-theme/certwise/quiz-widgets/quizfolder'
};

export default css;
